// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Profile/index.css
// module id = 2470
// module chunks = 0